import { Box, type BoxProps } from '@mui/material';
import { type ReactElement, useContext, useEffect, useState } from 'react';

import { SlabTabContext } from './SlabTabContext';
import { getPanelId, getTabId } from './utils';

export interface SlabTabPanelProps<T extends string> extends Omit<BoxProps, 'children'> {
  value: T;
  element?: ReactElement;
}

export const SlabTabPanel = <T extends string>({
  value,
  element,
  ...props
}: SlabTabPanelProps<T>): ReactElement | null => {
  const id = getPanelId(value);
  const tabId = getTabId(value);

  const { activeTab } = useContext(SlabTabContext);

  const [hasBeenActive, setHasBeenActive] = useState(value === activeTab);

  useEffect(() => {
    if (value === activeTab) setHasBeenActive(true);
  }, [value, activeTab]);

  if (!hasBeenActive) return null;

  return (
    <Box id={id} aria-labelledby={tabId} hidden={value !== activeTab} role='tabpanel' {...props}>
      {element}
    </Box>
  );
};
